import { render, staticRenderFns } from "./UserReferrals.vue?vue&type=template&id=385aef3d&scoped=true"
import script from "./UserReferrals.vue?vue&type=script&lang=js"
export * from "./UserReferrals.vue?vue&type=script&lang=js"
import style0 from "./UserReferrals.vue?vue&type=style&index=0&id=385aef3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385aef3d",
  null
  
)

export default component.exports